<template>
  <div class="exam-page">
    <my-breadcrumb :items="pagination"></my-breadcrumb>
    <div class="quiz-container p-5">
      <b-card title="Tryout History">
        <b-table striped hover :items="history" :fields="fields" show-empty>
          <template #cell(id)="data">
            #{{ data.item.id }}
          </template>
          <template #cell(tryout_name)="data">
            {{ data.item.tryout_level }} - {{ data.item.tryout_name }}
          </template>
          <template #cell(start_time)="data">
            Mulai: {{ $helpers.formatDateTimeID(data.item.start_time) }} <br>
            Selesai: {{ data.item.end_time ? $helpers.formatDateTimeID( data.item.end_time) : '-' }}
          </template>
          <template #cell(action)="data">
            <b-button size="sm" variant="primary" @click="openDetail(data.item)">
              Detail
            </b-button>
          </template>
        </b-table>
      </b-card>
    </div>

    <b-modal v-model="detailModal" hide-footer hide-header centered size="lg">
      <modal-close @click="detailModal = false"></modal-close>
      <h4 class="mt-3 text-center">
        {{item.tryout_name}}
      </h4>
      <div class="bg-white p-4 mt-3">
        <div class="text-left text-md-right p-0 p-md-3">
          <p class="py-3">
            Waktu pengerjaan tryout
          </p>
          <p class="quiz-integral__when d-inline p-2 my-2">
            {{ $helpers.formatDateTimeID(item.start_time)}}
          </p>
        </div>

        <img
          class="quiz-integral__img mt-5 mt-md-0"
          src="/img/quiz/selamat.png"
        />
        <h2 class="text-center mt-3">
          Review 
        </h2>

        <tryout-summary class="mt-4" :result="item"> </tryout-summary>

        <div class="ajustify-center mt-4 pb-5">
          <my-button class="m-2 px-5 btn-font sm-w-100" type="fill-blue" @click="retry">
            <fa-icon class="mr-1" icon="redo-alt"></fa-icon>
            Ulangi Tryout
          </my-button>
          <my-button class="m-2 px-5 btn-font sm-w-100" @click="openAnswer">
            <fa-icon class="mr-1" icon="search"></fa-icon>
            Pembahasan Jawaban
          </my-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TryoutSummary from "../components/TryoutSummary";
import { mapGetters, mapActions } from "vuex";
import * as types from "../store/types";

export default {
  components: { TryoutSummary },
  data() {
    return {
      history: [],
      item: {
        tryout_name: '', 
        start_time: '',
        detail: []
      },
      pagination: [
        {
          text: 'Tryout',
          url: '#'
        }, 
        {
          text: 'History',
          url: '#'
        }
      ], 
      fields: [
        { key: 'id' }, 
        { key: 'tryout_name' }, 
        { key: 'start_time', label: 'Time' }, 
        { key: 'action' }
      ], 
      detailModal: false
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN
    })
  },
  mounted() {
  	if (this.isLoggedIn) {
      this.tryoutHistory();
    } else {
     var link = "/login?redirect=tryout-history"
      this.$router.push(link);
    }
  },
  watch: {
  	isLoggedIn: function(newVal) {
  		if(newVal) {
  			this.tryoutHistory();
  		} else {
  			var link = "/login?redirect=tryout-history"
        this.$router.push(link);
  		}
  	}
  },
  methods: {
    ...mapActions({
    	getTryoutHistory: types.GET_TRYOUT_HISTORY
    }),
    tryoutHistory() {
      this.getTryoutHistory()
      .then(response => {
        this.history = response
      }).catch(error => {
        this.$helpers.showMessageBox(this, error, "Failed to get tryout history", "danger");
      })
    },
    openDetail(item) {
      this.item = item
      this.detailModal = true
    },
    retry() {
      this.$router.push('/tryout/' + this.item.tryout_id)
    },
    openAnswer() {
      this.$helpers.showMessageBox(this, 'Coming Soon', 'Coming Soon', 'success')
    }
  }
};
</script>

<style>
.quiz-integral {
  padding: 22px;
  padding-top: 0;
}

.quiz-integral__p {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.86;
  color: #000000;
  max-width: 477px;
}

.quiz-integral__img {
  width: 85px;
  height: 83.1px;
  margin: auto;
  display: block;
}

.quiz-integral__when {
  color: #ff4e4b;
  background-color: #feedec;
}

.btn-font {
  font-size: 14px;
  font-weight: bold;
}

@media only screen and (max-width: 768px) {
  .quiz-integral {
    padding: 15px;
  }
}
</style>
